import * as t from 'io-ts';

export const linkValidationRuleSchema = t.type({
  option: t.string,
  option_validator: t.string
}, 'linkValidationRuleSchema');
export type LinkValidationRuleType = t.TypeOf<typeof linkValidationRuleSchema>;
